import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=25aa2beb&scoped=true&"
import script from "./GroupForm.vue?vue&type=script&lang=js&"
export * from "./GroupForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=25aa2beb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa2beb",
  null
  
)

export default component.exports